
export class SaleDetailsDto {
    
    assetId : number;
    approvedBy: string;
    assetSaleCost: string;
    status: string;
    reason: string;

    constructor(assetId : number,approvedBy: string,assetSaleCost: string,status: string,reason: string){
        this.assetId = assetId;
        this.approvedBy = approvedBy;
        this.assetSaleCost = assetSaleCost;
        this.status = status;
        this.reason = reason;

    }

}